require('re-tree');
require('./ng-device-detector');
module.exports = 'ng.deviceDetector';


//////////////////
// WEBPACK FOOTER
// ./~/ng-device-detector/index.js
// module id = 165
// module chunks = 1